// globals.ts
import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  mainTitle: string = 'Stawika';
}